<!-- 调用
<photo-wall height="35vw" data-aos="fade-up" :photos="waterPhotos" :more="waterMore" :rowNum="5" :swap="2" :autoPlay="false"></photo-wall>

waterPhotos: [
  [
    {title: '茶理理', image: '/static/images/up/chalili.png'}
    {title: '肥皂菌', image: '/static/images/up/feizaojun.png'}
    {title: '果哝双子', image: '/static/images/up/guonongshuangzi.png'}
  ],
]
-->

<template>
  <div class="photo-wall" :style="{width: width, height: height}">
    <photo-wall-item v-for="(item,index) of photos" :key="index" :photos="item" :style="`width: ${photoWidth}%`"></photo-wall-item>

    <div class="photo-wall-more" v-if="Object.keys(more).length > 0" :style="`width: ${photoWidth}%`">
      <a class="photo-wall-more-image" v-if="more.image" :href="more.url" target="_blank" :style="`background-image: url(${more.image});`"></a>
      <span v-else class="photo-wall-more-text" v-html="more.text"></span>
    </div>
  </div>
</template>

<script>
import PhotoWallItem from './PhotoWallItem'

export default {
  name: 'Collapse',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '25.5vw'
    },
    photos: { //图片数据源
      type: Array,
      default: []
    },
    rowNum: { //每行显示的数量
      type: Number,
      default: 4
    },
    more: { //是否有更多按钮,可不填
      type: Object,
      default: () => ({})
    },
    timer: { //图片切换时间
      type: Number,
      default: 5000
    },
    swap: { //同时切换图片数量
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      photoWidth: 0
    }
  },
  components: {
    PhotoWallItem,
  },
  methods: {
    //生成随机数
    randomNum(minNum, maxNum){
      switch(arguments.length){
        case 1:
          return parseInt(Math.random()*minNum+1,10);
        case 2:
          return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
        default:
          return 0;
      }
    },
    animation() {
      let random = this.randomNum(0, this.photos.length - 1)
      this.$children.forEach((child,index) => {
        if(index === random) {
          child.play()
        }
      })
    }
  },
  mounted() {
    for(let i=1; i<=this.swap; i++){
      setInterval(this.animation, this.timer)
    }
  },
  created() {
    this.photoWidth = parseFloat(100 / this.rowNum)
  }
}
</script>

<style lang="scss" scoped>
.photo-wall {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.photo-wall-more {
  position: relative;
  overflow: hidden;

  .photo-wall-more-image {
    position: absolute;
    width: 100%;
    height: 100%;
    background: center / cover no-repeat;
  }

  .photo-wall-more-text {
    background-color: rgba(0,0,0,.4);
    color: #ffffff;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
